<template>
  <div>
    <el-select v-model="value" placeholder="请选择">
      <el-option v-for="item in options" :key="item.id" :label="item.name" :value="item.id"></el-option>
    </el-select>
    <el-button @click="chaxun(value)">查询</el-button>
    <el-table :data="moduledata" style="width: 100%">
      <el-table-column prop="id" label="模块ID" width="280px"></el-table-column>
      <el-table-column prop="moduleField" label="模块标识ID"></el-table-column>
      <el-table-column prop="moduleName" label="模块名称"></el-table-column>
      <el-table-column prop="moduleContent" label="脚本"></el-table-column>
      <el-table-column label="操作" width="280px">
        <template slot-scope="scope">
          <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
          <el-button size="mini" type="danger" @click="handleDelete(scope.$index, moduledata)">删除</el-button>
          <el-dialog title="编辑产品" :visible.sync="dialochanpin" width="50%">
            <el-form :model="form" label-width="80px">
              <el-form-item label="ID">
                <el-input v-model="form.id"></el-input>
              </el-form-item>
              <el-form-item label="模块ID">
                <el-input v-model="form.moduleField"></el-input>
              </el-form-item>
              <el-form-item label="模块名称">
                <el-input v-model="form.moduleName"></el-input>
              </el-form-item>
              <el-form-item label="脚本">
                <el-input v-model="form.moduleContent"></el-input>
              </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
              <el-button @click="dialochanpin = false">取 消</el-button>
              <el-button type="primary" @click="bianjimokuai(form)">确 定</el-button>
            </span>
          </el-dialog>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
export default {
  data() {
    return {
      dialochanpin: false,
      moduledata: [],
      form: {
        id: "",
        moduleField: "",
        moduleName: "",
        moduleContent: "",
      },
      options: [],
      value: "",
    };
  },
  mounted() {
    this.moduledata = [];
    this.chaxunchanpin();
  },
  methods: {
    chaxun(row) {
      this.moduledata = [];
      let formData = new FormData();
      formData.append("productId", row);
      this.$http
        .post(this.$getaxiosurl("/enc/product/getModuleByProductId"), formData)
        .then((response) => {
          if (response.data.code == "00100") {
            for (var i = 0; i < response.data.data.length; i++) {
              this.moduledata.push(response.data.data[i]);
            }
          } else {
            this.$message({
              message: response.data.msg,
              type: "success",
              duration: 8000,
            });
          }
        });
    },
    chaxunchanpin() {
      this.$http
        .post(this.$getaxiosurl("/enc/product/getAllProduct"))
        .then((res) => {
          if (res.data.code == "00100") {
            for (var i = 0; i < res.data.data.length; i++) {
              this.$set(this.options, i, res.data.data[i]);
            }
          } else {
            this.$message({
              message: res.data.msg,
              type: "success",
              duration: 8000,
            });
          }
        });
    },
    handleEdit(index, row) {
      this.dialochanpin = true;
      Object.assign(this.form, row);
    },
    hetongDelete(index) {
      this.moduledata.splice(index, 1);
    },
    bianjimokuai(row) {
      let formData = new FormData();
      formData.append("id", row.id);
      formData.append("moduleField", row.moduleField);
      formData.append("moduleName", row.moduleName);
      formData.append("content", row.moduleContent);
      this.$http
        .post(this.$getaxiosurl("/enc/product/editModule"), formData)
        .then((response) => {
          if (response.data.code == "00100") {
            this.$message({
              message: response.data.msg,
              type: "success",
              duration: 8000,
            });
            this.dialochanpin = false;
          } else {
            this.$message({
              message: response.data.msg,
              type: "success",
              duration: 8000,
            });
          }
        });
    },
  },
};
</script>
<style scoped>
</style>
